
import { Component, Vue, Prop } from 'vue-property-decorator'
import lsPagination from '@/components/ls-pagination.vue'
import { RequestPaging } from '@/utils/util'
import config from '@/config'
import LsUpload from '@/components/ls-upload.vue'
import {
    apiSettleLists,
    apiSettleView,
    apiSettleExport,
    apiSettleReject,
    apiSettleVouncher,
    apiSettleConfirmServiceFee
} from '@/api/settle'
@Component({
    components: {
        lsPagination,
        LsUpload
    }
})
export default class AiList extends Vue {
    $refs!: any
    tableData: Array<object> = []
    AuditTime: Array<object> = []
    pager = new RequestPaging()
    scoreappleVisible: Boolean = false //查看
    scoreGrant: Boolean = false //发放
    params: any = {
        id: '',
        status: 2
    }
    action = `${config.baseURL}/platformapi/upload/image`
    version = config.version
    scoreReject: Boolean = false // 驳回
    Rejects: any = {
        id: '',
        status: 3
    }
    dialogVisible: any = false
    dialogImageUrl: any = ''
    platformRecords: any = [] //平台上传图片
    supplierRecords: any = [] //供应商上传图片
    fileList: any = []
    rejectReason: any = ''
    settleId: any = ''
    isPass: any = false
    isPass2: any = false
    certificateShow: any = false
    activeName: any = ''
    search: any = {
        state: '',
        startTime: '',
        endTime: '',
        supplier: '',
        id: '',
        page: 1,
        size: 10
    }

    tabs = [
        {
            label: '全部',
            name: ''
        },
        {
            label: '待结算',
            name: '1'
        },
        {
            label: '待审核',
            name: '2'
        },
        {
            label: '审核驳回',
            name: '3'
        },
        {
            label: '待打款',
            name: '4'
        },
        {
            label: '待确认',
            name: '5'
        },
        {
            label: '确认驳回',
            name: '6'
        },
        {
            label: '已结算',
            name: '7'
        }
    ]
    settleCycle: any = ''
    imgs: any = []
    viewListApply: any = {}
    url: any = ''
    handleCurrentChange(val: any) {
        this.viewListApply = val
        this.url = val.voucher
        this.params.id = val.id
        this.Rejects.id = val.id
    }
    // 拆分时间
    splitStartTime() {
        if (this.tableData != null) {
            this.search.startTime = this.tableData[0]
            this.search.endTime = this.tableData[1]
        }
    }
    //查看数据
    close() {
        this.platformRecords = []
        this.supplierRecords = []
        this.settleCycle = ''
    }
    viewImg(url: any) {
        this.dialogImageUrl = url
        this.dialogVisible = true
    }
    //申请列表
    searchview(page?: number) {
        page == 1 && (this.search.page = page)
        this.search.state = this.activeName == 0 ? '' : this.activeName
        this.pager
            .request({
                callback: apiSettleLists,
                params: {
                    ...this.search
                }
            })
            .then(res => {})
    }
    change(response: any, file: any, fileList: any) {
        this.imgs = fileList.map((item: any) => {
            return item.response.data.uri
        })
    }
    remove(file: any, fileList: any) {
        this.imgs = fileList.map((item: any) => {
            return item.response.data.uri
        })
    }
    //查看
    scoreView(val: any) {
        this.scoreappleVisible = true
        apiSettleView({ settleId: val.id }).then(res => {
            this.platformRecords = res.platformRecords
            this.supplierRecords = res.supplierRecords
            this.settleCycle = res.settleCycle
        })
    }
    uncertificate(val: any) {
        this.certificateShow = true
        this.settleId = val.id
        this.searchview(1)
    }
    checkIsPass(val: any) {
        this.isPass = true
        this.settleId = val.id
    }
    checkIsPass2(val: any) {
        this.isPass2 = true
        this.settleId = val.id
    }
    isPassTrue() {
        if (this.rejectReason == '') {
            this.$message({
                type: 'error',
                message: `请输入驳回原因`
            })
            return
        }
        apiSettleReject({
            settleId: this.settleId,
            rejectReason: this.rejectReason
        }).then(res => {
            this.$message({
                type: 'success',
                message: `驳回成功`
            })
            this.searchview(1)
            this.isPass = false
        })
    }
    exportData(val: any) {
        const loading = this.$loading({
            lock: true,
            text: '正在导出中...',
            spinner: 'el-icon-loading'
        })
        apiSettleExport({ settleId: val.id })
            .then(res => {
                window.location.href = res.fileUrl
            })
            .finally(() => {
                loading.close()
            })
    }
    certificatetrue() {
        if (this.imgs.length == 0) {
            return
        }
        apiSettleVouncher({ imgs: this.imgs, settleId: this.settleId }).then(res => {
            this.$message({
                type: 'success',
                message: `上传成功`
            })
            this.certificateShow = false
        })
    }
    isPassFalse() {
        apiSettleConfirmServiceFee({
            settleId: this.settleId
        }).then(res => {
            this.$message({
                type: 'success',
                message: `success`
            })
            this.searchview(1)
            this.isPass2 = false
        })
    }
    //发放
    scoreviewGrant() {
        this.scoreGrant = true
    }
    //驳回
    scoreviewReject() {
        this.scoreReject = true
    }
    //发放积分
    scoreGrants() {}
    //驳回申请
    scoreviewRejects() {
        this.scoreReject = false
        apiSettleReject(this.Rejects)
            .then((res: any) => {
                this.$alert('您已成功驳回本次申请', '驳回成功', {
                    confirmButtonText: '确定',
                    //   center: true,
                    callback: action => {
                        this.$message({
                            type: 'success',
                            message: `驳回成功`
                        })
                    }
                })
                this.searchview(1)
            })
            .catch(err => {})
    }
    searchSelect(value: any) {
        this.search.status = value
    }
    //重置表单
    reset() {
        this.tableData = []
        Object.keys(this.search).map(key => {
            this.$set(this.search, key, '')
        })
        this.searchview(1)
    }
    created() {
        this.searchview(1)
    }
}
